// TEMPORARY on-device reload tracer (2026-09-28) — to find what still makes a live screen reload with
// loading placeholders (LIVE_UPDATES_NO_POLLING_PLAN.md, step 1 fix). Off for everyone. Switched on per
// device with ?livetrace=1 on any app URL (remembered on that device), off again with ?livetrace=0.
// While on, a small box at the bottom-left lists the last reloads: time · screen · FULL / quiet · why.
// Remove this file and its calls once the culprit is found and fixed.

const KEY = 'llLiveTrace';
const MAX = 8;
let panel: HTMLElement | null = null;
const lines: string[] = [];

function enabled(): boolean {
  try {
    const q = new URLSearchParams(location.search).get('livetrace');
    if (q === '1') localStorage.setItem(KEY, '1');
    if (q === '0') localStorage.removeItem(KEY);
    return localStorage.getItem(KEY) === '1';
  } catch {
    return false;
  }
}

/** Records one reload. kind: 'FULL' = shows loading / placeholders, 'quiet' = live, change-only. */
export function liveTrace(screen: string, kind: 'FULL' | 'quiet' | 'event', why: string): void {
  if (!enabled()) return;
  try {
    const t = new Date();
    const hh = [t.getHours(), t.getMinutes(), t.getSeconds()].map(n => String(n).padStart(2, '0')).join(':');
    lines.unshift(`${hh}  ${screen}  ${kind}  ${why}`);
    lines.length = Math.min(lines.length, MAX);
    if (!panel) {
      panel = document.createElement('div');
      panel.style.cssText =
        'position:fixed;left:8px;bottom:8px;z-index:99999;pointer-events:none;max-width:min(92vw,520px);' +
        'font:11px/1.4 monospace;background:rgba(0,0,0,.82);color:#d7f7c8;padding:6px 8px;border-radius:8px;' +
        'white-space:pre-wrap;';
      document.body.appendChild(panel);
    }
    panel.textContent = 'Reload trace (newest first)\n' +
      lines.map(l => (l.includes('  FULL  ') ? '⚠ ' : '  ') + l).join('\n');
  } catch { /* tracing must never break the page */ }
}
